module.exports = __webpack_public_path__ + "img/WCA-Membership.864ced51.png";